import { SEO } from "@/components/SEO";
import { Hero } from "@/components/home/Hero";
import { WorkGlimpseSection } from "@/components/home/WorkGlimpseSection";
import { ClientLogosSection } from "@/components/home/ClientLogosSection";
import { SolutionsSection } from "@/components/home/SolutionsSection";
import { BrandMessageSection } from "@/components/home/BrandMessageSection";
import { FinalCTA } from "@/components/home/FinalCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO
        title="We Build Businesses To Grow"
        description="DULORME LABS builds brands, marketing systems and AI-powered growth infrastructure for ambitious businesses."
        path="/"
      />
      <Hero />
      <WorkGlimpseSection />
      <ClientLogosSection />
      <SolutionsSection />
      <BrandMessageSection />
      <FinalCTA />
    </div>
  );
}
